import React, { ReactNode } from 'react'
import Button from './GroupsTable/Button'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    if ((error as any).name === 'ChunkLoadError') {
      return { hasError: true }
    }
    return { hasError: false }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.log('Chunk load error caught by ErrorBoundary:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload() // full reload to get latest chunks
  }

  getColorCode = (value: string): string => {
    let color = ''
    switch (value) {
      // Telemetry History chart color
      case 'infoBlue':
        color =
          process.env.REACT_APP_COLOR === 'hitron'
            ? '#004C97'
            : process.env.REACT_APP_COLOR === 'customer'
            ? '#ff974c'
            : process.env.REACT_APP_COLOR === 'entpnt'
            ? '#487a7b'
            : '#6581fa'
        break
    }
    return color
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Oops! Something went wrong while loading the page.</h2>
          <Button
            className={`text-white px-3 py-2 rounded-md text-[13px] w-[150px] text-center uppercase`}
            onClick={this.handleReload}
            style={{
              background: this.getColorCode('infoBlue')
            }}
          >
            Reload
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}
